import * as React from "react";
const NoInfo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <rect width={40} height={40} fill="#F1F5F9" rx={20} />
    <path
      fill="#475569"
      d="M15 17v-2h14v2H15Zm0 4v-2h14v2H15Zm0 4v-2h14v2H15Zm-3-8a.968.968 0 0 1-.713-.288A.968.968 0 0 1 11 16c0-.283.096-.52.287-.713A.968.968 0 0 1 12 15c.283 0 .52.096.713.287.191.192.287.43.287.713s-.096.52-.287.712A.968.968 0 0 1 12 17Zm0 4a.968.968 0 0 1-.713-.288A.968.968 0 0 1 11 20c0-.283.096-.52.287-.712A.968.968 0 0 1 12 19c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.712A.968.968 0 0 1 12 21Zm0 4a.968.968 0 0 1-.713-.288A.968.968 0 0 1 11 24c0-.283.096-.52.287-.712A.968.968 0 0 1 12 23c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.712A.968.968 0 0 1 12 25Z"
    />
  </svg>
);
export default NoInfo;
